"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragment = exports.default = void 0;
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _ModalHeader = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/ModalHeader"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _useSesame = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useSesame"));
var _client = require("@apollo/client");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Heading = _interopRequireDefault(require("./designsystem/Heading"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _OperatingHours = _interopRequireDefault(require("./OperatingHours"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const fragment = exports.fragment = (0, _client.gql)`
    fragment CompanyOperatingHours on Company {
        normalOperatingHours {
            monday {
                ...TimeOpenClosed
            }
            tuesday {
                ...TimeOpenClosed
            }
            wednesday {
                ...TimeOpenClosed
            }
            thursday {
                ...TimeOpenClosed
            }
            friday {
                ...TimeOpenClosed
            }
            saturday {
                ...TimeOpenClosed
            }
            sunday {
                ...TimeOpenClosed
            }
        }

        specialOperatingHours {
            startDate
            endDate
            monday {
                ...TimeOpenClosed
            }
            tuesday {
                ...TimeOpenClosed
            }
            wednesday {
                ...TimeOpenClosed
            }
            thursday {
                ...TimeOpenClosed
            }
            friday {
                ...TimeOpenClosed
            }
            saturday {
                ...TimeOpenClosed
            }
            sunday {
                ...TimeOpenClosed
            }
        }
    }
    fragment TimeOpenClosed on TimeOpenClosed {
        timeOpen
        timeClosed
    }
`;
const CompanyOperatingHours = ({
  data: {
    normalOperatingHours,
    specialOperatingHours
  }
}) => {
  const {
    onClose,
    open,
    onOpen
  } = (0, _useSesame.default)();
  return __jsx(_react.default.Fragment, null, __jsx(_Heading.default, {
    mt: 5
  }, __jsx(_Title.default, {
    elementType: "h2"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "XSoILw",
    defaultMessage: [{
      "type": 0,
      "value": "Openingstijden"
    }]
  }))), normalOperatingHours && __jsx(_OperatingHours.default, {
    operatingHours: normalOperatingHours
  }), !!specialOperatingHours.length && __jsx(_react.default.Fragment, null, __jsx(_Button.default, {
    onClick: onOpen,
    variant: "outline",
    style: {
      marginTop: '3.2rem'
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "dZsgT6",
    defaultMessage: [{
      "type": 0,
      "value": "Afwijkende openingstijden"
    }]
  })), __jsx(_Modal.default, {
    variant: "small",
    open: open,
    onClose: onClose
  }, __jsx(_ModalHeader.default, null, __jsx(_reactIntl.FormattedMessage, {
    id: "7Jxy7v",
    defaultMessage: [{
      "type": 0,
      "value": "Afwijkingen"
    }]
  })), specialOperatingHours.map((period, periodIndex) => {
    if (!period) {
      return null;
    }
    return __jsx(_react.Fragment, {
      key: periodIndex
    }, __jsx(_Heading.default, {
      mb: 2,
      mt: 4,
      variant: "tiny"
    }, __jsx(_Body.default, {
      variant: "large"
    }, __jsx(_reactIntl.FormattedMessage, {
      id: "PCQh9C",
      defaultMessage: [{
        "type": 0,
        "value": "Van "
      }, {
        "type": 1,
        "value": "startDate"
      }, {
        "type": 0,
        "value": " t/m "
      }, {
        "type": 1,
        "value": "endDate"
      }],
      values: {
        startDate: __jsx(_reactIntl.FormattedDate, {
          value: period.startDate,
          format: "WEEKDAYMONTH"
        }),
        endDate: __jsx(_reactIntl.FormattedDate, {
          value: period.endDate,
          format: "WEEKDAYMONTH"
        })
      }
    }))), __jsx(_OperatingHours.default, {
      operatingHours: period
    }), periodIndex !== specialOperatingHours.length - 1 && __jsx(_Divider.default, {
      my: 4
    }));
  }))));
};
var _default = exports.default = CompanyOperatingHours;